{
  "name": "cockpit",
  "version": "0.6.17",
  "scripts": {
    "ng": "ng",
    "start": "ng serve -o",
    "build-dev": "ng build --configuration=development",
    "build-prod": "ng build --configuration=production",
    "copy-dev": "node transfer.js dev",
    "copy-prod": "node transfer.js prod"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.3.18",
    "@angular/common": "^20.3.18",
    "@angular/compiler": "^20.3.18",
    "@angular/core": "^20.3.18",
    "@angular/forms": "^20.3.18",
    "@angular/platform-browser": "^20.3.18",
    "@angular/platform-browser-dynamic": "^20.3.18",
    "@angular/router": "^20.3.18",
    "@fortawesome/fontawesome-free": "^7.2.0",
    "@googlemaps/markerclusterer": "^2.6.2",
    "bootstrap": "^5.3.8",
    "chart.js": "^4.5.1",
    "chartjs-plugin-datalabels": "^2.2.0",
    "moment": "^2.30.1",
    "ng2-charts": "^8.0.0",
    "ngx-bootstrap": "^20.0.1",
    "ngx-toastr": "^19.1.0",
    "rxjs": "~7.8.2",
    "sweetalert2": "^11.17.2",
    "tslib": "^2.8.1",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular/build": "^20.3.21",
    "@angular/cli": "^20.3.21",
    "@angular/compiler-cli": "^20.3.18",
    "@types/chart.js": "^4.0.1",
    "@types/google.maps": "^3.58.1",
    "@types/node": "^24.5.2",
    "node-ssh": "^13.2.1",
    "typescript": "~5.9.2",
    "zip-a-folder": "^3.1.9"
  }
}
